import React, { useState, useRef, useEffect } from "react";
import Select from "react-select";
import { FiEdit2 } from "react-icons/fi";
import Breadcrumb from "../../../../components/layout/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { useHasPermission } from "../../../../hooks/useHasPermission";
import {
  fetchTicketById,
  addComment,
  reAssignTicket,
  fetchAssignmentUsers,
  getTicketDoc,
  markTicketProcessing,
  approveTicket,
  partialApproveTicket,
  rejectTicket,
  verifyTicket,
  reworkTicket,
  closeTicket,
  escalateTicket,
} from "../../../../redux/slice/supportSlice";
import CommentSection from "../../../../features/portal/support/components/CommentSection";
import { toast, ToastContainer } from "react-toastify";
import ProfileUpdateSection from "../../../../features/portal/support/components/ProfileUpdateSection";

function InfoRow({ label, value }) {
  let finalValue;
  if (React.isValidElement(value)) {
    finalValue = value;
  } else {
    const cleanValue = typeof value === 'string' ? value.trim() : String(value ?? "");
    finalValue = cleanValue !== "" ? cleanValue : "N/A";
  }
  return (
    <div className="d-flex align-items-center justify-content-between mb-2">
      <span className="profile-label">{label}</span>
      <p className="profile-label-value text-dark m-0">
        {finalValue ?? "-N/A-"}
      </p>
    </div>
  );
}

InfoRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
};

function InfoRowPersonal({ label, value, className = "" }) {
  let finalValue;
  if (React.isValidElement(value)) {
    finalValue = value;
  } else {
    const cleanValue = typeof value === 'string' ? value.trim() : String(value ?? "");
    finalValue = cleanValue !== "" ? cleanValue : "N/A";
  }
  return (
    <div className={`col-md-6 d-flex align-items-center justify-content-between mb-2 unique-personal-row-item ${className}`}>
      <span className="d-inline-flex align-items-center unique-personal-label">
        {label}:
      </span>
      <p className="text-dark m-0 unique-personal-value text-right">
        {finalValue ?? "-N/A-"}
      </p>
    </div>
  );
}

InfoRowPersonal.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  className: PropTypes.string,
};

export default function TicketDetail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    selectedTicket,
    loading,
    error,
    commentLoading,
    assignmentUsers,
    reassignLoading,
    actionLoading,
  } = useSelector((state) => state.support);

  const currentUser = useSelector((state) => state.auth?.user);
  const InitialPermissionData = useSelector(
    (state) => state.persistedReducer?.forms?.savedPermissions
  );

  const loggedInUserId = InitialPermissionData?.userId || currentUser?.id;

  //console.log("===== LOGGED IN USER ID =====", loggedInUserId);

  const canView = useHasPermission("Support-view");
  const canManage = useHasPermission("Support-manage");
  const canEscalatedView = useHasPermission("Support_escalated-view");
  const canEscalatedManage = useHasPermission("Support_escalated-manage");
  const canAllManageTickets = useHasPermission("Support-all-manage");
  const currentRole = localStorage.getItem("role");

  const isSuperAdmin =
    currentRole === "SUPER_ADMIN" ||
    currentUser?.role === "SUPER_ADMIN" ||
    [
      "superadmin-hrms@moptra.com",
      "superadmin@moptra.com",
    ].includes(currentUser?.email);

  const canEscalateTicket =
    isSuperAdmin || canEscalatedManage || canEscalatedView;

  const [activeTab, setActiveTab] = useState("conversation");

  const [openSections, setOpenSections] = useState({
    about: false,
    personal: false,
    bank: false,
    family: false,
    nominee: false,
    education: false,
    experience: false,
    address: false,
    additional: false,
  });

  const fileInputRef = useRef(null);

  /* ================= HELPERS ================= */
  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatLabel = (value) => {
    if (!value) return "";
    return value
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const hasCategory = (categoryName) => {
    return ticket.subCategories?.split(",").map(item => item.trim()).includes(categoryName);
  };

  /* ================= Reassign HR List ================= */
  const [loadingAssignments, setLoadingAssignments] = useState(false);

  const ticket = selectedTicket || {};
  const isSelfAssigned = Number(ticket?.assignedToUserId) === Number(loggedInUserId);
  const showApprovedSection = ticket.category === "PROFILE_UPDATE" && ticket.status !== "CREATED"

  const canAccessThisTicket =
    isSuperAdmin ||
    canAllManageTickets ||
    isSelfAssigned;
  const canAccessTicketActions = canAccessThisTicket;

  // console.log("===== TICKET ACCESS DEBUG =====");
  // console.log("ticket.id =>", ticket?.id);
  // console.log("ticket.assignedToUserId =>", ticket?.assignedToUserId);
  // console.log("loggedInUserId =>", loggedInUserId);
  // console.log("isSelfAssigned =>", isSelfAssigned);
  // console.log("canView =>", canView);
  // console.log("canManage =>", canManage);
  // console.log("canAllManageTickets =>", canAllManageTickets);
  // console.log("canAccessThisTicket =>", canAccessThisTicket);
  // console.log("========= ALL assignmentUsers =========", assignmentUsers);

  const hrOptions = assignmentUsers
    ?.filter((item) => item.isActive)
    ?.map((item) => {
      console.log("Dropdown Item => ", item);
      return {
        value: item.assignedToUserId,
        label: `${item.assignedToName || `${item.assignedToUserName} -`
          } (${formatLabel(item.categoryName)})`,
      };
    });

  console.log("========= FINAL hrOptions =========", hrOptions);
  const openAssignModal = async () => {
    try {
      setLoadingAssignments(true);
      console.log("Fetching assignment users...");
      const response = await dispatch(fetchAssignmentUsers()).unwrap();

      console.log("fetchAssignmentUsers RESPONSE ==========>", response);

      setShowAssignModal(true);
    } catch (err) {
      console.error("ASSIGNMENT FETCH ERROR ===========>", err);

    } finally {
      setLoadingAssignments(false);
    }
  };

  /* ================= Reassign to another HR ================= */
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedHR, setSelectedHR] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [actionRemarks, setActionRemarks] = useState("");
  const [remarksError, setRemarksError] = useState("");
  const [deadlineDays, setDeadlineDays] = useState(7);
  const [selectedFieldGroups, setSelectedFieldGroups] = useState([]);
  console.log('=====', selectedFieldGroups);

  const handleReAssign = async () => {
    if (!selectedHR) return;
    try {
      await dispatch(
        reAssignTicket({
          ticketId: ticket.id,
          payload: {
            assignToUserId: selectedHR.value,
            remarks,
          },
        })
      ).unwrap();
      dispatch(fetchTicketById(ticket.id));
      setShowAssignModal(false);
      setSelectedHR(null);
      setRemarks("");
    } catch (err) {
      console.error(err);
    }
  };

  /* ================= FETCH ================= */
  useEffect(() => {
    if (id) {
      dispatch(fetchTicketById(id));
    }
  }, [dispatch, id]);

  // useEffect(() => {
  //   if (!loading && ticket?.id) {
  //     if (!canAccessThisTicket) {
  //       console.log("ACCESS DENIED");
  //       toast.error("You are not authorized to access this ticket");
  //       navigate("/admin/support/hr/");
  //     }
  //   }
  // }, [
  //   loading,
  //   ticket,
  //   canAccessThisTicket,
  //   navigate,
  // ]);

  const toggleSection = (sectionName) => {
    setOpenSections((prev) => ({
      ...prev,
      [sectionName]: !prev[sectionName],
    }));
  };
  const handleDownloadDoc = async (ticketId, fileName, fileType) => {
    try {
      const responseData = await dispatch(
        getTicketDoc({ ticketId, fileName, fileType })
      ).unwrap();

      let mimeType = 'application/octet-stream'; // Default
      if (fileType.toLowerCase() === 'pdf') mimeType = 'application/pdf';
      else if (['png', 'jpg', 'jpeg'].includes(fileType.toLowerCase())) {
        mimeType = `image/${fileType.toLowerCase() === 'jpg' ? 'jpeg' : fileType.toLowerCase()}`;
      }

      const fileBlob = new Blob([responseData], { type: mimeType });
      if (fileBlob.size === 0) {
        toast.error("File content is empty!");
        return;
      }

      const fileURL = window.URL.createObjectURL(fileBlob);
      const newTab = window.open(fileURL, "_blank");
      if (newTab) newTab.focus();
      setTimeout(() => window.URL.revokeObjectURL(fileURL), 10000);

    } catch (err) {
      console.error("Blob Error:", err);
      toast.error(err || "Failed to render document!", { className: 'toast-error-custom' });
    }
  };

  /* ================= PROFILE UPDATE SECTIONS ================= */
  const PROFILE_SECTIONS = [
    "PERSONAL_INFORMATION",
    //"DOCUMENT_UPLOAD",
    "BANK_DETAILS",
    "NOMINEE",
    "ADDITIONAL_DETAILS",
    //"PROFESSIONAL_REFERENCE",
    "EXPERIENCE",
    "EDUCATION",
    "ADDRESS",
    "INSURANCE_DEPENDENT",
  ];
  /* ================= CTA VISIBILITY HELPERS ================= */

  const isClosedTicket = [
    "CLOSED",
    "REJECTED",
  ].includes(ticket.status);

  const canCloseTicket =
    ticket.category === "PROFILE_UPDATE"
      ? ticket.status === "VERIFIED"
      : ["APPROVED", "VERIFIED"].includes(ticket.status);

  const canShowEscalateButton =
    ["REJECTED", "CLOSED"].includes(ticket.status) &&
    canEscalateTicket;

  const canShowActionPanel =
    canAccessTicketActions && !isClosedTicket;

  /* ================= AUTO SELECT PROFILE UPDATE SECTIONS ================= */
  useEffect(() => {
    if (
      ticket.category === "PROFILE_UPDATE" &&
      ticket.subCategories
    ) {
      const mappedSections = ticket.subCategories
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
      setSelectedFieldGroups(mappedSections);
    }
  }, [ticket.category, ticket.subCategories]);

  /* ================= HANDLE SECTION TOGGLE ================= */
  const handleSectionToggle = (section, checked) => {
    if (checked) {
      setSelectedFieldGroups((prev) =>
        prev.includes(section) ? prev : [...prev, section]
      );
    } else {
      setSelectedFieldGroups((prev) =>
        prev.filter((item) => item !== section)
      );
    }
  };

  /* ================= HANDLE TICKET ACTION ================= */
  const handleTicketAction = async (type) => {
    if (!actionRemarks.trim()) {
      setRemarksError("Remarks are required");
      return;
    }
    try {
      let action;
      const payload = {
        remarks: actionRemarks?.trim() || "",
      };

      switch (type) {
        case "PROCESSING":
          action = markTicketProcessing({
            ticketId: ticket.id,
            payload,
          });
          break;

        case "APPROVE":
          if (
            ticket.category === "PROFILE_UPDATE" &&
            selectedFieldGroups.length === 0
          ) {
            toast.error("Please select at least one section");
            return;
          }
          action = approveTicket({
            ticketId: ticket.id,
            payload: {
              ...payload,
              approvedFieldGroups:
                ticket.category === "PROFILE_UPDATE"
                  ? selectedFieldGroups
                  : undefined,
            },
          });
          break;

        case "PARTIAL_APPROVE":
          if (selectedFieldGroups.length === 0) {
            toast.error("Please select at least one section");
            return;
          }

          action = partialApproveTicket({
            ticketId: ticket.id,
            payload: {
              ...payload,
              deadlineDays: Number(deadlineDays || 0),
              approvedFieldGroups: selectedFieldGroups,
            },
          });
          break;

        case "REJECT":
          action = rejectTicket({
            ticketId: ticket.id,
            payload,
          });
          break;

        case "VERIFY":
          action = verifyTicket({
            ticketId: ticket.id,
            payload,
          });
          break;

        case "REWORK":
          action = reworkTicket({
            ticketId: ticket.id,
            payload: {
              ...payload,
              deadlineDays: Number(deadlineDays || 0),
            },
          });
          break;

        case "CLOSE":
          action = closeTicket({
            ticketId: ticket.id,
            payload,
          });
          break;

        case "ESCALATE":
          action = escalateTicket({
            ticketId: ticket.id,
            payload,
          });
          break;

        default:
          return;
      }

      await dispatch(action).unwrap();
      toast.success(`Ticket ${type.replace('_', " ").toLowerCase()} successfully!`);
      dispatch(fetchTicketById(ticket.id));
      setActionRemarks("");
      setDeadlineDays(7);
    } catch (err) {
      console.error(err);
      toast.error(err || "--Action failed!--");
    }
  };
  const comments = Array.isArray(ticket.comments) ? ticket.comments : [];
  const auditLogs = Array.isArray(ticket.auditLogs) ? ticket.auditLogs : [];
  return (
    <div className="container-fluid" style={{ marginBottom: "30px" }}>
      <Breadcrumb
        overrideTrail={[
          { name: "Dashboard", path: "/admin/dashboard" },
          { name: "Support", path: "/admin/support" },
          { name: "HR", path: "/admin/support/hr" },
          { name: `Ticket (${ticket?.id || id})` },
        ]}
      />
      <div className="section-body">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header border-0 bg-white pb-4">
              <button className="btn btn-link text-decoration-none mb-3 ps-0 fw-medium primary-btn"
                onClick={() => navigate("/admin/support/hr/")}>
                ← Back to tickets
              </button>

              {/* LOADING */}
              {loading && <p className="server-error-msg">-- Loading ticket details... --</p>}

              {/* NO DATA */}
              {!loading && !ticket.id && (
                <p className="server-error-msg">-- No ticket data found --</p>
              )}

              {/* MAIN CONTENT */}
              {!loading && ticket.id && canAccessThisTicket ? (
                <div className="view-support_ticket-body">
                  <section className="conversation-container">
                    <div className="header-wrapper">
                      <div className="tocket-title d-flex justify-content-between">
                        <h2 className="issue-title mb-2">
                          {ticket.title || "-"}
                        </h2>
                      </div>
                      <div className="title-row">
                        <span className="ticket-id">
                          <label>Ticket ID: </label> #TKT-{ticket.id}
                        </span>
                      </div>
                      <div className="meta-grid">
                        <div className="meta-item">
                          <label className="text-secondary-dark font-weight-bold mb-0">Creator Name:</label>
                          <div className="meta-value">
                            {ticket.createdByName || "-"}
                          </div>
                        </div>
                        <div className="meta-item">
                          <label className="text-secondary-dark font-weight-bold mb-0">Created:</label>
                          <div className="meta-value">
                            {formatDate(ticket.createdAt)}
                          </div>
                        </div>
                        <div className="meta-item assigned-user-card flex-column">
                          <label className="assigned-title text-secondary-dark font-weight-bold mb-0">Assigned To:</label>
                          <div className="assigned-user-wrapper">
                            <div className="assigned-user-left">
                              <div className="assigned-avatar primary-btn">
                                {ticket.assignedToName?.charAt(0) || "H"}
                              </div>

                              <div>
                                <div className="assigned-user-name">
                                  {ticket.assignedToName || "Unassigned"}
                                </div>
                                <div className="assigned-user-subtitle">
                                  Assign to another person or team
                                </div>
                              </div>
                            </div>

                            {canAccessTicketActions && (
                              <button className="edit-assign-btn" onClick={openAssignModal} >
                                <FiEdit2 size={16} />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                      <hr className="divider" />
                      <div className="description-grid">
                        <label className="text-secondary-dark font-weight-bold mb-0">Issue Description:</label>
                        <p className="issue-description"> {ticket.description || "-"} </p>
                      </div>
                      <div className="view-attachment-grid">
                        <label className="text-secondary-dark font-weight-bold mb-0">View Attachment:</label>
                        <div className="attachment-container">
                          {ticket.attachments && ticket.attachments.length > 0 ? (
                            ticket.attachments.map((file) => (
                              <div key={file.id} className="attachment-badge">
                                <i className="fa fa-file-pdf-o me-2"></i>
                                <button type="button" className="btn btn-link attachment-link p-0" onClick={() => handleDownloadDoc(ticket.id, file.fileName, file.fileType)}>
                                  {file.fileName}
                                </button>
                              </div>
                            ))
                          ) : (
                            <p className="server-error-msg mb-1">-- No attachments provided --</p>
                          )}
                        </div>
                      </div>
                    </div>
                    <hr className="divider m-0" />
                    <div className="tabs">
                      <button className={`tab ${activeTab === "conversation" ? "active" : ""}`} onClick={() => setActiveTab("conversation")}>
                        Conversation
                      </button>

                      {ticket.category === "PROFILE_UPDATE" && (
                        <button type="button" className={`tab ${activeTab === "profileUpdates" ? "active" : ""}`} onClick={() => setActiveTab("profileUpdates")}>
                          Profile Updates
                        </button>
                      )}

                      <button className={`tab ${activeTab === "activity" ? "active" : ""}`} onClick={() => setActiveTab("activity")} >
                        Ticket Activity
                      </button>
                    </div>

                    {/* PROFILE UPDATES */}
                    {activeTab === "profileUpdates" && (
                      <ProfileUpdateSection
                        ticket={ticket}
                        hasCategory={hasCategory}
                        openSections={openSections}
                        toggleSection={toggleSection}
                        InfoRow={InfoRow}
                        InfoRowPersonal={InfoRowPersonal}
                      />
                    )}

                    <div className="messages-area">
                      {activeTab === "conversation" && (
                        <CommentSection
                          comments={comments}
                          loading={commentLoading}
                          activeTab={activeTab}
                          onSend={async (payload) => {
                            try {
                              await dispatch(addComment({ ticketId: id, payload })).unwrap();
                            } catch (err) {
                              console.error(err);
                            }
                          }}
                        />
                      )}
                      {activeTab === "activity" &&
                        <div className="timeline-content p-3">
                          {auditLogs.length === 0 ? (
                            <p className="server-error-msg text-center">-- No activity found --</p>
                          ) : (
                            <div className="activity-timeline">
                              {auditLogs?.map((log, index) => (
                                <div className="timeline-item" key={log.id}>
                                  {/* Left Timeline */}
                                  <div className="timeline-left">
                                    <div className="timeline-dot">
                                      {log?.performedByName?.charAt(0)}
                                    </div>
                                    {index !== auditLogs.length - 1 && (
                                      <div className="timeline-line"></div>
                                    )}
                                  </div>

                                  {/* Right Content */}
                                  <div className="timeline-content">
                                    <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                                      <div>
                                        <h6 className="mb-1 fw-bold">
                                          {log.performedByName}
                                        </h6>
                                        <div className="d-flex align-items-center flex-wrap gap-2">
                                          <span className={`activity-badge ${log.action}`}>
                                            {log.action.replaceAll("_", " ")}
                                          </span>
                                          {log.fromStatus && (
                                            <span className="status-flow">
                                              {formatLabel(log.fromStatus)}
                                              <i className="fa fa-arrow-right mx-2"></i>
                                              {formatLabel(log.toStatus)}
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                      <small className="text-muted">
                                        {formatDate(log.performedAt)}
                                      </small>
                                    </div>
                                    {log.remarks && (
                                      <div className="remarks-box mt-2">
                                        {formatLabel(log.remarks)}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      }
                    </div>
                    <Modal centered show={showAssignModal} onHide={() => setShowAssignModal(false)} size="md" >
                      <Modal.Header className="border-1 pb-1 text-center">
                        <div>
                          <h4 className="fw-bold mb-1 mt-0">Reassign Ticket</h4>
                          <p className="text-muted mb-0 small">Assign this ticket to another HR</p>
                        </div>
                      </Modal.Header>
                      <Modal.Body className="pt-3">
                        <div className="current-assigned-box mb-4">
                          <span className="current-label">Currently Assigned</span>

                          <div className="current-user">
                            <div className="current-avatar primary-btn">
                              {ticket.assignedToName?.charAt(0) || "H"}
                            </div>
                            <div>
                              <p className="fw-semibold mb-0">
                                {ticket.assignedToName || "Unassigned"}
                              </p>
                              <small className="text-muted">
                                Current ticket owner
                              </small>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">Select another HR</label>
                          <Select
                            options={hrOptions}
                            value={selectedHR}
                            onChange={setSelectedHR}
                            placeholder="Search HR here..."
                            isSearchable
                            classNamePrefix="react-select"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label fw-semibold">Remarks</label>
                          <textarea
                            rows={4}
                            className="form-control"
                            placeholder="Enter reassignment remarks..."
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                          />
                        </div>

                        <button className="assign-submit-btn primary-btn" onClick={handleReAssign} disabled={!selectedHR || reassignLoading} >
                          {reassignLoading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Re-assigning...
                            </>
                          ) : (
                            "Submit Re-assignment"
                          )}
                        </button>
                      </Modal.Body>
                    </Modal>
                  </section>
                  <div className="details-sidebar">
                    <div className="sidebar-card">
                      <h3>Ticket Details</h3>

                      <div className="detail-group">
                        <label>Status: </label>
                        <span className={`badge ${ticket.status?.toLowerCase()?.replace("_", "-")}`} >
                          {formatLabel(ticket.status || "-")}
                        </span>
                      </div>

                      <div className="detail-group">
                        <label>Priority: </label>
                        <span className="badge priority-red"> {ticket.priority || "-"}
                        </span>
                      </div>

                      <div className="detail-group">
                        <label>Category: </label>
                        <span>{formatLabel(ticket.category)}</span>
                      </div>
                    </div>

                    {ticket.subCategories && (
                      <div className="sidebar-card">
                        <h3>Profile Update Request</h3>
                        <div className="profile-fields">
                          {ticket.subCategories.split(",").map((item, index) => (
                            <label key={index} className="checkbox-item">
                              <input type="checkbox" checked readOnly />
                              {formatLabel(item)}
                            </label>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* ================= TICKET ACTIONS ================= */}
                    <div className="sidebar-card">
                      <h3>Ticket Actions </h3>
                      {!canAccessTicketActions ? (
                        <div className="text-center py-3">
                          <span className="badge bg-secondary">
                            No Permission
                          </span>

                          <p className="text-muted small mt-2 mb-0">
                            You are not authorized to manage this ticket
                          </p>
                        </div>
                      ) : canShowActionPanel ? (
                        <div className="hr-controls d-flex flex-column gap-2">
                          {/* REMARKS */}

                          {/* DEADLINE */}
                          {ticket.category === "PROFILE_UPDATE" &&
                            ticket.status === "IN_PROGRESS" && (
                              <div>
                                <label className="form-label mb-1">
                                  Deadline Days <span className="required">*</span>
                                </label>

                                <input
                                  type="number"
                                  className="form-control"
                                  min={1}
                                  value={deadlineDays}
                                  onChange={(e) =>
                                    setDeadlineDays(e.target.value)
                                  }
                                />
                              </div>
                            )}

                          {/* APPROVED SECTION */}
                          {showApprovedSection && (
                            <div className="border rounded p-2">
                              <div className="d-flex justify-content-between mb-2">
                                <h3>Approved Sections <span className="required">*</span></h3>

                                <small className="text-muted">
                                  {ticket.status === "IN_PROGRESS"
                                    ? `${selectedFieldGroups.length} selected`
                                    : `${ticket.fieldApprovals?.length || 0} approved`}
                                </small>
                              </div>

                              <div className="sidebar-card">
                                <div className="profile-fields-grid">
                                  {PROFILE_SECTIONS
                                    .filter((section) =>
                                      ticket.subCategories
                                        ?.split(",")
                                        .map((item) => item.trim())
                                        .includes(section)
                                    )
                                    .map((section) => {

                                      /* ================= IN PROGRESS ================= */
                                      const isEditable =
                                        ticket.status === "IN_PROGRESS";

                                      /* ================= APPROVED SECTIONS ================= */
                                      const approvedSections =
                                        ticket.fieldApprovals
                                          ?.filter((item) => item.isApproved)
                                          ?.map((item) => item.fieldGroupName) || [];

                                      /* ================= CHECKED STATE ================= */
                                      const isSelected = isEditable
                                        ? selectedFieldGroups.includes(section)
                                        : approvedSections.includes(section);

                                      return (
                                        <label
                                          key={section}
                                          htmlFor={section}
                                          className={`profile-checkbox-card 
                                                    ${isSelected ? "active" : ""}
                                                    ${!isEditable ? "disabled-card" : ""}
                                                  `}
                                        >
                                          <div className="d-flex align-items-center gap-2">
                                            <input
                                              type="checkbox"
                                              className="form-check-input"
                                              id={section}
                                              checked={isSelected}
                                              disabled={!isEditable}
                                              onChange={(e) =>
                                                handleSectionToggle(
                                                  section,
                                                  e.target.checked
                                                )
                                              }
                                            />

                                            <span className="checkbox-title">
                                              {formatLabel(section)}
                                            </span>
                                          </div>
                                        </label>
                                      );
                                    })}
                                </div>

                                {/* WARNING */}
                                {ticket.status === "IN_PROGRESS" &&
                                  selectedFieldGroups.length === 0 && (
                                    <div className="empty-selection-warning">
                                      <i className="fa fa-exclamation-circle me-2"></i>
                                      Select at least one section
                                    </div>
                                  )}
                              </div>
                            </div>
                          )}
                          <label className="form-label mb-1">
                            Remarks <span className="required">*</span>
                          </label>
                          <textarea
                            rows={3}
                            className={`form-control mb-2 ${remarksError ? "is-invalid" : ""}`}
                            placeholder="Enter remarks..."
                            value={actionRemarks}
                            onChange={(e) => {
                              setActionRemarks(e.target.value);
                              if (e.target.value.trim()) {
                                setRemarksError("");
                              }
                            }}
                          />

                          {remarksError && (
                            <div className="invalid-feedback d-block">
                              {remarksError}
                            </div>
                          )}
                          {/* CREATED */}
                          {ticket.status === "CREATED" && (
                            <button className="primary-btn"
                              disabled={actionLoading}
                              onClick={() =>
                                handleTicketAction("PROCESSING")
                              }>
                              {actionLoading
                                ? "Processing..."
                                : "Start Processing"}
                            </button>
                          )}

                          {/* IN_PROGRESS */}
                          {ticket.status === "IN_PROGRESS" && (
                            <>
                              {/* NORMAL TICKETS */}
                              {ticket.category !== "PROFILE_UPDATE" && (
                                <button
                                  className="primary-btn approve-btn"
                                  disabled={actionLoading}
                                  onClick={() => handleTicketAction("APPROVE")}
                                >
                                  {actionLoading ? "Approving..." : "Approve"}
                                </button>
                              )}

                              {/* PROFILE UPDATE */}
                              {ticket.category === "PROFILE_UPDATE" && (
                                <button
                                  className="primary-btn partial-btn"
                                  disabled={
                                    actionLoading ||
                                    selectedFieldGroups.length === 0
                                  }
                                  onClick={() =>
                                    handleTicketAction("PARTIAL_APPROVE")
                                  }
                                >
                                  {actionLoading
                                    ? "Submitting..."
                                    : "Approve Sections"}
                                </button>
                              )}

                              <button
                                className="secondary-btn reject-btn"
                                disabled={actionLoading}
                                onClick={() => handleTicketAction("REJECT")}
                              >
                                {actionLoading ? "Rejecting..." : "Reject"}
                              </button>
                            </>
                          )}

                          {/* UPDATED */}
                          {ticket.status === "UPDATED" && (
                            <>
                              <button
                                className="primary-btn"
                                disabled={actionLoading}
                                onClick={() =>
                                  handleTicketAction("VERIFY")
                                }
                              >
                                {actionLoading
                                  ? "Verifying..."
                                  : "Verify Data"}
                              </button>

                              <button
                                className="rework-btn"
                                disabled={actionLoading}
                                onClick={() =>
                                  handleTicketAction("REWORK")
                                }
                              >
                                {actionLoading
                                  ? "Sending..."
                                  : "Send For Rework"}
                              </button>
                            </>
                          )}

                          {/* APPROVED / VERIFIED */}
                          {canCloseTicket && (
                            <button
                              className="primary-btn"
                              disabled={
                                actionLoading
                              }
                              onClick={() =>
                                handleTicketAction("CLOSE")
                              }
                            >
                              {actionLoading
                                ? "Closing..."
                                : "Close Ticket"}
                            </button>
                          )}
                        </div>
                        // ) : canShowEscalateButton ? (
                        //   <div className="hr-controls d-flex flex-column gap-2">

                        //     <textarea
                        //       rows={3}
                        //       className="form-control"
                        //       placeholder="Enter escalation remarks..."
                        //       value={actionRemarks}
                        //       onChange={(e) =>
                        //         setActionRemarks(e.target.value)
                        //       }
                        //     />

                        //     <button
                        //       className="primary-btn"
                        //       disabled={
                        //         actionLoading ||
                        //         !actionRemarks.trim()
                        //       }
                        //       onClick={() =>
                        //         handleTicketAction("ESCALATE")
                        //       }
                        //     >
                        //       {actionLoading
                        //         ? "Escalating..."
                        //         : "Escalate Ticket"}
                        //     </button>

                        //   </div>
                      ) : (
                        <div className="text-center py-3">
                          <span className="badge bg-success">
                            Ticket Closed
                          </span>

                          <p className="text-muted small mt-2 mb-0">
                            No further actions available
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : !loading && ticket.id ? (
                <div className="text-center py-5">
                  <h5 className="server-error-msg">Access Denied</h5>
                  <p className="server-error-msg">You are not authorized to view this ticket.</p>
                </div>
              ) : null}
            </div>
            <ToastContainer />
          </div>
        </div>
      </div>
    </div >
  );
}